<template>
    <div>
        <v-app-bar app dense color="primary" dark :clipped-left="true">
            <v-app-bar-nav-icon 
                variant="text" 
                v-if='$store.getters.isAuthenticated'
                @click.stop="drawer = !drawer"
            />

            <v-row 
                class="d-flex align-center justify-space-between mx-4"
            >
                <v-toolbar-title>
                    Fincom Model Validation
                </v-toolbar-title>

                <!-- <v-spacer /> -->

                <!-- Centered Current Tenant -->
                <!-- <span v-if="userRole === ROLES.SYS_ADMIN && $store.getters.chosenTenant" class="mr-5">
                        Current tenant - {{ $store.getters.chosenTenant.name }}
                </span> 
                <v-chip 
                    v-else-if="$store.getters.userName" 
                    :class='userRole === ROLES.SYS_ADMIN && "mr-2"'>
                        <v-icon class='mr-2'>mdi-account-tie</v-icon>
                        {{ $store.getters.userName }}
                </v-chip> --> 
                <!-- Right side: Tenant Picker and Logout -->
                <!-- <TenantsPickerMenu 
                    v-if="userRole === ROLES.SYS_ADMIN"
                    @chooseTenant="chooseTenant"
                /> -->
                <v-chip >
                    <v-icon class='mr-2'>mdi-account-tie</v-icon>
                    {{ $store.getters.userName }}
                </v-chip>
                <v-icon v-if="userRole" @click="doLogout" size="30" class="mx-3">mdi-logout</v-icon>

            </v-row>
        </v-app-bar>
        
        <v-navigation-drawer
            temporary
            v-if="$store.getters.isAuthenticated"
            v-model='drawer'
            :location="$vuetify.display.mobile ? 'bottom' : undefined"
            class='elevation-1'
            width="350"
        > 
            <v-list nav>
                <template v-for='item in filteredItems'>
                    <!-- Multi items with children -->
                    <v-list-group
                        v-if='item.children'
                        :key='item.icon'
                        :prepend-icon='item.icon'
                    >
                        <template v-slot:activator='{ props }'>
                        <v-list-item
                            v-bind='props'
                            :disabled='handleDisabledButton(item)'
                        >
                            <div>
                            {{ item.name }}
                            </div>
                        </v-list-item>
                        </template>

                        <v-list-item
                            v-for='child in item.children'
                            :key='child.name'
                            :prepend-icon='child.icon'
                            :value='child.path'
                            @click='routeTo(child)'
                            :style=' {
                                "padding-left": "30px !important", 
                                "cursor": child?.disabled && child.disabled() ? "not-allowed" : "pointer",
                                "color":  child?.disabled && child.disabled() ? "grey" : ""
                            }'
                        >
                        <div class="d-flex justify-space-between">
                            <span v-if="child?.disabled && child.disabled()">
                                <v-tooltip :text="child.disabledText">
                                    <template v-slot:activator="{ props }">
                                        <span v-bind="props">{{ child.name }}</span>
                                    </template>
                                </v-tooltip>
                            </span>
                            <span v-else>
                                {{ child.name }}
                            </span>
                            <span v-if="child.showIcon">
                                <v-icon
                                    v-if="isSurveySubmitted(child.name)"
                                    color="success"
                                >
                                    mdi-check-circle
                                </v-icon>
                                <v-icon
                                    v-else
                                    color="grey"
                                >
                                    mdi-close-circle
                                </v-icon>
                            </span>
                        </div>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                        v-else-if='item.path === "button"'
                        :key='item.path'
                        :prepend-icon='item.icon'
                        :value='item.path'
                        @click='displayModal'
                        :disabled="item.isDisabled()"
                    >
                        <div v-if="item.isDisabled()">
                            Already requested assessment
                        </div>
                        <div v-else>
                            {{ item.name }}
                        </div>
                    </v-list-item>
                    <!-- Single items -->
                    <v-list-item
                        v-else
                        :key='item.name'
                        :prepend-icon='item.icon'
                        :value='item.path'
                        @click='routeTo(item)'
                    >
                        <div>
                        {{ item.name }}
                        </div>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
    </div>
    <ConfirmModal 
        v-if="!isTenantAuditor && tenantRails?.length"
        title='Request assessment'
        confirmText='Send request'
        :text='`Request assessment? <br />assessment will be requested on the following tests: <br /> ${$store.getters.submittedQuestionnaires ? $store.getters.submittedQuestionnaires.join(", ") : ""}`'
        :dialog='showModal'
        @closeConfirmModal='handleRequestAssessment'
    />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import { isEqual, sortBy } from 'lodash'
import { SET_CURRENT_TENANT, CLEAR_SUMMARY_REPORT } from '@/store/actions/modelValidation';
import TenantsPickerMenu from './systemConfigs/TenantsPickerMenu.vue';
import ConfirmModal from './ConfirmModal.vue';
import { ROLES }  from '@/helpers/actionRoles';
import { railsTests } from '@/utils/dataLabels';

export default {
    components: {
        TenantsPickerMenu,
        ConfirmModal
    },
    data() {
        return {
            drawer: false,
            ROLES,
            chosenTenant: null,
            showModal: false,
            submissionObject: {
                "General Questionnaire": railsTests.GENERAL,
                "Wire Questionnaire": `screening_${railsTests.WIRE}`,
                "ACH Questionnaire": `screening_${railsTests.ACH}`,
                "Instant Payment Questionnaire": `screening_${railsTests.INSTANT_PAYMENT}`,
                "Monitoring Questionnaire": `screening_${railsTests.MONITORING}`,
                "Name Matching": railsTests.TEST_NAMES,
                "Wires Screening": railsTests.TEST_WIRE,
                "Monitoring": railsTests.TEST_MONITORING,  
            },
        };
    },
    computed: {
        ...mapGetters(['isAuthenticated', 'userName', 'userRole']),
        isUserAuditor() {
            return [ROLES.CHIEF_AUDITOR, ROLES.AUDITOR].includes(this.userRole)
        },
        tenantRails() {
            return this.$store.getters?.tenantRails;
        },
        isTenantAuditor() {
            return [ROLES.CHIEF_AUDITOR, ROLES.AUDITOR].includes(this.userRole)
        },
        items() {            
            // const isPrimary = localStorage.getItem('isPrimary') === 'true';
            const isUserSysAdmin = this.userRole == ROLES.SYS_ADMIN;
            return [
                {
                    name: 'Home page',
                    icon: 'mdi-home',
                    path: 'startUp',
                    show: function() {
                        return true;
                    } 
                },
                {
                    name: 'Start',
                    icon: 'mdi-ticket-confirmation',
                    path: this.isTenantAuditor ? 'Questionnaire504-TABLES' : 'rails',
                    show: function() {
                        const isTenantHasRails = !this.isTenantAuditor && this.$store.getters.tenantRails?.length;

                        return !isTenantHasRails;
                    } 
                },
                {
                    name: 'Name Compare',
                    icon: 'mdi-tag-check',
                    children: [
                       {
                            name: 'Create New Sample',
                            icon: 'mdi-face-man-profile',
                            path: 'newSamples',
                            show: function() {
                                return true
                            }
                        },
                        {
                           name: 'Create New Test',
                            icon: 'mdi-test-tube',
                            path: 'tests',
                            show: function() {
                                return true
                            }
                        },
                        {
                            name: 'Run Comparison',
                            icon: 'mdi-compare',
                            path: 'uploadResults',
                            show: function() {
                                return true
                            }
                        },
                        {
                            name: 'Generate Reports',
                            icon: 'mdi-coffee-maker-check',
                            path: 'finishedRuns',
                            show: function() {
                                return true
                            }
                        },
                    ],
                    show: function() {
                        return isUserSysAdmin;
                    },
                },
                {
                    name: 'Questionnaires',
                    icon: 'mdi-file-question-outline',
                    children: [
                        {
                            name: 'General Questionnaire',
                            icon: 'mdi-file-question',
                            path: 'Questionnaire504-GENERAL',
                            showIcon: true,
                            show: function() {
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole)
                            }
                        },
                        {
                            name: 'Wire Questionnaire',
                            icon: 'mdi-file-question',
                            path: 'Questionnaire504-WIRE',
                            showIcon: true,
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(`screening_${railsTests.WIRE}`)
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole) && isRailInTenant
                            }
                        },
                        {
                           name: 'ACH Questionnaire',
                            icon: 'mdi-file-question',
                            path: 'Questionnaire504-ACH',
                            showIcon: true,
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(`screening_${railsTests.ACH}`)
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole) && isRailInTenant
                            }
                        },
                        {
                           name: 'Instant Payment Questionnaire',
                            icon: 'mdi-file-question',
                            path: 'Questionnaire504-RTP',
                            showIcon: true,
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(`screening_${railsTests.INSTANT_PAYMENT}`)
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole) && isRailInTenant
                            }
                        },
                        {
                            name: 'Monitoring Questionnaire',
                            icon: 'mdi-file-question',
                            path: 'Questionnaire504-MONITORING',
                            showIcon: true,
                            show: function() {
                                const isRailsActive = this.$store.getters?.tenantRails?.length
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole) && isRailsActive
                            }
                        },
                        // {
                        //    name: 'Reviewed by Consultant',
                        //     icon: 'mdi-file-multiple',
                        //     path: 'Questionnaire504-FINISHED-ASSESSMENT',
                        //     show: function() {
                        //         const isUserSysAdmin = this.userRole == ROLES.SYS_ADMIN;
                        //         const isAssessmentSubmitted = this.$store.getters.submittedQuestionnaires?.includes("auditor assessment");
                        //         const isAssessmentAvailable = isAssessmentSubmitted && [ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole)
                        //         return isUserSysAdmin || isAssessmentAvailable;
                        //     }
                        // },
                        {
                            name: 'Pending Review',
                            // name: 'Questionnaires',
                            icon: 'mdi-help-box-multiple',
                            path: 'Questionnaire504-TABLES',
                            show: function() {
                                return [ROLES.SYS_ADMIN, ROLES.CHIEF_AUDITOR, ROLES.AUDITOR].includes(this.userRole)
                            }
                        },
                    ],
                    show: function() {
                        const isUserSysAdmin = this.userRole == ROLES.SYS_ADMIN;
                        const isTenantHasRails = ![ROLES.ADMIN, ROLES.AUDITOR_ADMIN].includes(this.userRole) && this.$store.getters?.tenantRails?.length;
                        return isTenantHasRails || isUserSysAdmin;
                    } 
                },
                {
                    name: 'Technical Tests',
                    icon: 'mdi-sitemap',
                    children: [
                        // Name matching
                        {
                            name: 'Name Matching',
                            icon: 'mdi-numeric-1-circle',
                            path: 'Questionnaire504-NAME-MATCHING',
                            showIcon: true,
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(railsTests.TEST_NAMES)
 
                                return isRailInTenant || isUserSysAdmin;
                            }
                        },
                        // Wires transactions
                        {
                            name: 'Wires Screening',
                            icon: 'mdi-numeric-2-circle',
                            path: 'Questionnaire504-WIRES-SCREENING',
                            showIcon: true,
                            disabled: () => {
                                const isQuestionnaireSubmitted = this.$store.getters.submittedQuestionnaires?.includes(`screening_${railsTests.WIRE}`);
                                return !isQuestionnaireSubmitted;
                            },
                            disabledText: 'Wires questionnaire is not submitted',
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(railsTests.TEST_WIRE);
                                return isRailInTenant || isUserSysAdmin;
                            }
                        },
                        // Monitoring
                        {
                            name: 'Monitoring',
                            icon: 'mdi-numeric-3-circle',
                            path: 'Questionnaire504-MONITORING-TEST',
                            showIcon: true,
                            show: function() {
                                const isRailInTenant = this.$store.getters?.tenantRails?.includes(railsTests.TEST_MONITORING)
                                return isRailInTenant || isUserSysAdmin;
                            }
                        },
                    ],
                    show: function() {                        
                        const isTenantHasTechnicalTests = this.$store.getters?.tenantRails?.some(rail => rail.includes('technical_test'))
                        return isUserSysAdmin || isTenantHasTechnicalTests
                        // return true
                    }
                },
                {
                    name: 'Reports',
                    icon: 'mdi-file-chart',
                    children: [
                        {
                            name: '504 - Reviewed by Consultant',
                            icon: 'mdi-file-multiple',
                            path: 'Questionnaire504-FINISHED-ASSESSMENT',
                            show: function() {
                                const isUserSysAdmin = this.userRole == ROLES.SYS_ADMIN;
                                const tenantSubmission = this.$store.getters.submittedQuestionnaires || []
                                const isAssessmentSubmitted = tenantSubmission?.includes("assessment finished");                                
                                const isAssessmentAvailable = isAssessmentSubmitted && [ROLES.CHIEF_USER, ROLES.USER].includes(this.userRole)
                                return isUserSysAdmin || isAssessmentAvailable;
                            }
                        },
                        {
                            name: 'Name Match',
                            icon: 'mdi-coffee-maker-check',
                            path: 'finishedRuns',
                            show: function() {
                                return true
                            }
                        },
                    ],
                    show: function() {
                        return !this.isUserAuditor
                    }
                },
                {
                    name: 'User Management',
                    icon: 'mdi-security',
                    path: 'users',
                    show: function() {
                        return [ROLES.ADMIN, ROLES.AUDITOR_ADMIN].includes(this.userRole)
                    } 
                },
                {
                    name: 'System',
                    icon: 'mdi-security',
                    children: [
                        {
                            name: 'User Management',
                            icon: 'mdi-account-multiple-outline',
                            path: 'users',
                            show: function() {
                                return true
                            }
                        },
                        {
                            name: 'Tenant Management',
                            icon: 'mdi-bank',
                            path: 'tenants',
                            show: function() {
                                return true
                            }
                        },
                        {
                            name: 'Questionnaire Configuration',
                            icon: 'mdi-file-edit',
                            path: 'questionnaireEditor',
                            show: function() {
                                return true
                            }
                        },
                        {
                            name: 'System Configuration',
                            icon: 'mdi-robot-happy',
                            path: 'systemConfiguration',
                            show: function() {
                                return true
                            }
                        },
                    ],
                    show: function() {
                        return isUserSysAdmin;
                    }
                },
                {
                    name: 'General Settings',
                    icon: 'mdi-ticket-confirmation',
                    path: 'rails',
                    show: function() {
                        const isTenantHasRails = this.$store.getters?.tenantRails?.length;

                        return (!this.isTenantAuditor && isTenantHasRails);
                    } 
                },
                {
                    name: 'Request assessment',
                    icon: 'mdi-receipt-text-send',
                    path: 'button',
                    isDisabled: function() {
                        // if a user already requested an assessment                      
                        return localStorage.getItem('assessmentRequest') == 'true';
                    },
                    show: function() {
                        const submittedQuestionnaires = this.$store.getters.submittedQuestionnaires || [];
                        const tenantRails = this.$store.getters?.tenantRails; 
                        const canSubmitRequest = tenantRails?.length && isEqual(sortBy(submittedQuestionnaires), sortBy(tenantRails));

                        return canSubmitRequest && !isUserSysAdmin && !this.isTenantAuditor;
                    } 
                },
                {
                    name: 'Review Assessment questionnaires',
                    icon: 'mdi-printer-eye',
                    path: 'preview-assessment',
                    show: function() {
                        return localStorage.getItem('assessmentRequest') == 'true';
                    } 
                },
                {
                    name: 'Review Submitted Questionnaires',
                    icon: 'mdi-file-multiple',
                    path: 'submittedQuestionnaires',
                    show: function() {
                        return !this.isUserAuditor && localStorage.getItem('assessmentRequest') == 'false';
                    } 
                },
            ]
        },
        filteredItems() {
          return this.items
            .filter(item => typeof item.show === 'function' ? item.show.call(this) : item.show)
            .map(item => {
              if (item.children) {
                return {
                  ...item,
                  children: item.children.filter(child => typeof child.show === 'function' ? child.show.call(this) : child.show),
                };
              }
              return item;
            });
        },
    },
    watch: {
        isAuthenticated(newValue) {
            if (!newValue) {
                this.$router.go({ name: 'login' });
            }
        },
    },
    methods: {
        ...mapActions({ logout: AUTH_LOGOUT, setCurrentTenant: SET_CURRENT_TENANT, clearSummaryReport: CLEAR_SUMMARY_REPORT }),
        updateToggle(value) {
            this.isDrawerOpen = value;
        },
        handleDisabledButton(item) {
            if (this.isUserAuditor) return false;
            return item.name !== "Start" && (!this.tenantRails?.length);
        },
        isSurveySubmitted(name) {
            const submittedQuestionnaires = this.$store.getters.submittedQuestionnaires || [];
            return submittedQuestionnaires.includes(this.submissionObject[name])            
        },
        async doLogout() {
            this.setCurrentTenant('');
            this.clearSummaryReport();
            const username = localStorage.getItem('user-name')
            await this.logout(username);
            this.$router.go({ name: 'login' });
        },
        routeTo(page) {
            const currentPath = window.location.pathname;
            if (currentPath !== `/${page.path}`) {
                this.$router.push({ name: page.path });
            }
        },
        async chooseTenant(tenant) {
            this.chosenTenant = tenant;
            try {
                await this.setCurrentTenant(tenant)            
            } catch (e) {
                console.error(e);
                
            }
        },
        displayModal() {
            this.showModal = true;
        },
        async handleRequestAssessment(answer) {
            let message = 'Assessment requested successfully.';
            let type = 'success';
            if (answer) {
                try {
                    // send an update 
                    await this.$modelValidationClient.updateAssessmentRequest(this.$store.getters.tenantId, true);
                    localStorage.setItem('assessmentRequest', true);
                } catch (e) {
                    message = 'Failed to send assessment request, please contact Fincom support';
                    type = 'error';
                } finally {
                    this.$toast.open({
                        message,
                        type,
                        position: 'bottom'
                    })
                }
                
            }
            this.showModal = false
        }
    },
};
</script>
